import {
  badWords,
  disallowHtml,
  isEmail,
  maxLength,
  type Validator,
} from '@seek/validators-js';
import { z } from 'zod';

const requiredFieldMessage = 'Required Field';

export const requiredStringValidator = z
  .string()
  .min(1, { message: requiredFieldMessage });

export const requiredArrayValidator = z
  .array(z.string())
  .min(1, { message: requiredFieldMessage });

const toZodValidator =
  <
    ValidatorProps = Record<string, unknown>,
    ValidatorLanguage extends string = 'en',
  >(
    validator: Validator<string, ValidatorProps, undefined, ValidatorLanguage>,
  ) =>
  (props: ValidatorProps) =>
  (schema: z.ZodString) => {
    const param = (value: string) => ({
      value,
      validatorProps: props,
      formValues: undefined,
    });

    return schema.superRefine(async (value, ctx) => {
      const isValid = validator.test(param(value));
      if (!isValid) {
        const message = await validator.getErrorMessage(param(value));
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message,
        });
      }
    });
  };

export const isEmailValidator = toZodValidator(isEmail)({})(z.string());
export const badWordsValidator = toZodValidator(badWords)({})(z.string());
export const maxLengthValidator = (max: number) =>
  toZodValidator(maxLength)({ max })(z.string());
export const disallowHtmlValidator = toZodValidator(disallowHtml)({})(
  z.string(),
);
